import axios from 'axios'

export default {
    async getDictList({ commit }) {
        const data = await axios.get('dict')
        commit('setDictList', data.data)
        return data.data
    },

    async getTableData({ commit }, form) {
        commit('setTableDataLoading', true)
        const data = await axios.post('getTableData', { form })
        commit('setTableData', data.data)
        commit('setTableDataLoading', false)
        return data.data
    },

    async getSpecialityList({ commit }, form) {
        commit('setSpecialityListLoading', true)
        const data = await axios.post('getSpecialityList', { form })
        commit('setSpecialityList', data.data)
        commit('setSpecialityListLoading', false)
        return data.data
    },

    async getSpecialityGroup({ commit }, form) {
        commit('setSpecialityGroupLoading', true)
        const data = await axios.post('getSpecialityGroup', { form })
        commit('setSpecialityGroup', data.data)
        commit('setSpecialityGroupLoading', false)
        return data.data
    },

    async savePredictAnswer(state, params) {
        const data = await axios.post('savePredictAnswer', params)
        return data.data
    }
}
